const cn = {
  translation: {
    //misc
    hello: "你好",
    name: "姓名",
    "full name": "全名",
    phone: "电话",
    "phone number": "电话号码",
    email: "电邮",
    "email address": "电邮地址",
    address: "地址",
    password: "密码",
    "password confirmation": "确认密码",
    maintenance: "复购",
    "view all": "浏览全部",
    usd: "美金",
    "product description": "产品讯息",
    "shipping fee": "运费",
    "Contact Customer Service": "联系客服",
    "add to cart": "加入购物车",
    total: "总共",
    "direct downline": "直属下线",
    downline: "下线",
    "sponsor genealogy": "推广系谱",
    "placement genealogy": "安置系谱",
    "click on username to view further downline if any":
      "单击用户名以查看进一步的下线（如有）",
    search: "搜索",
    "bonus summary": "奖金总结",
    "no items in the cart": "暂无商品",
    "add some": "加入",
    "proceed to checkout": "结算",
    subtotal: "小计",
    tax: "税",
    "grand total": "总计",
    loading: "载入中",
    "no products found": "没有商品",
    update: "更改",
    //side menu
    "register account": "注册账户",
    login: "登录",
    "my profile": "我的账户",
    resource: "资源",
    "repeat purchase": "重复购买",
    "my order": "我的订单",
    cart: "购物车",
    policy: "政策",
    "contact us": "聯繫我們",
    "log out": "登出",
    //footer
    home: "主页",
    news: "新闻",
    community: "社群",
    wallet: "钱包",
    //Breadcrumb
    back: "返回",
    //contact us
    "get in touch": "保持联系",
    "Get in touch how you like, the choice is yours":
      "若你需要, 保持联系, 是你的选择",
    "drop us a line": "请给我们留言",
    "enter your name": "输入您的姓名",
    "enter email address": "输入您的电邮地址",
    subject: "项目",
    "enter your subject": "输入您的项目",
    message: "讯息",
    "enter your message": "输入您的讯息",
    submit: "提交",
    //login
    "enter your password": "输入您的密码",
    "don't have an account": "没有帐户？",
    "register now": "现在注册",
    "please click here": "请按这里",
    //forget password
    "forget password": "忘记密码",
    username: "用户名",
    "reset password": "重新设置密码",
    //Privacy
    "term of use": "使用条款",
    "privacy agreement": "隐私协议",
    "refund and return agreement": "退款和退货协议",
    "merchant service agreement": "商户服务协议",
    //register
    sponsor: "推广员",
    placement: "安置员",
    "placement position": "安置位置",
    left: "左",
    right: "右",
    "nric/passport no": "身份证号码/护照号码",
    "address line 1": "地址 分行 1",
    "address line 2": "地址 分行 2",
    state: "州属",
    postcode: "邮政编码",
    city: "城市",
    "minimum 8 characters, at least one uppercase letter, one lowercase letter, and one number":
      "最少八个字, 包括一个大写字母, 一个小写字母和一个号码",
    "already have an account": "已经有户口",
    "sign in now": "即刻登入",
    register: "注册",
    enter: "请输入",
    "enter your": "请输入您的",
    //profile
    profile: "账户",
    "edit profile": "更改账户",
    "edit bank information": "更改银行户口",
    "change password": "更改密码",
    "change security password": "更改安全密码",
    "my address": "我的地址",
    //Bank Name
    "bank name": "银行名",
    "bank holder name": "银行持有人姓名",
    "bank account": "银行户口",
    "bank swift": "银行代码",
    "bank swift code": "银行代码",
    //password
    "for your account's security, do not share your password with anyone else":
      "为了你的安全着想, 不要与其他人分享您的密码",
    "current password": "当前密码",
    "new password": "新密码",
    "confirm password": "确认密码",
    confirm: "确认",
    // security password
    "current security password": "当前安全密码",
    "new security password": "新安全密码",
    "confirm security password": "确认安全密码",
    //address
    "add new address": "加新地址",
    "delete address": "删除地址",
    reset: "重置",
    //product
    filter: "搜索",
    categories: "类别",
    "buy now": "购买",
    date: "日期",
    "Self Pick Up Address": "自取地址",
    "order Id": "订单号",
    "paid by": "付款方式",
    order: "订单",
    "to ship": "待发货",
    completed: "已完成",
    rejected: "已拒绝",
    //wallet
    convert: "兑换",
    "convert now": "兑换",
    transfer: "转入",
    transaction: "交易",
    withdraw: "提取",
    "withdrawal history": "提取记录",
    "convertable balance": "可兑换余额",
    "convert amount": "转换金额",
    amount: "金额",
    "select wallet": "选择钱包",
    "convert wallet": "转换钱包",
    remark: "备注",
    "withdrawal now": "提款",
    "security password": "安全密码",
    "transferable balance": "可转让余额",
    "transaction history": "交易记录",
    "no transaction history": "无交易记录",
    "date & time": "日期时间",
    "id & no.": "编号",
    done: "结束",
    "withdrawable balance": "可提款余额",
    withdrawal: "提款",
    "withdraw charges": "提款费用",
    "amount withdrawal minimum 50, maximum 5000": "提现金额最小50,最大5000",
    "no withdrawal history": "无提款记录",
    status: "状态",
    "charges fee": "收费",
    "bank info": "银行信息",
    "transfer to": "转入至",
    "transfer amount": "转入金额",
    "transfer now": "转入",
    //schema
    "is required": "是必须的",
    "must be at least 8 characters": "必须至少 8 个字符",
    "password must match": "密码必须匹配",
    "Password criteria 1":
      "密码必须至少包含 1 个大写字母、1 个小写字母和 1 个数字",
    "register member": "注册会员",
    file: "文件",
    "not exists": "不存在",
    "Enter To": "请输入",
  },
};

export default cn;
